import { SET_ONBOARDING_NEEDED } from "./onboardingConstants"

export function setOnboardingNeeded(value) {
    return {
        type: SET_ONBOARDING_NEEDED,
        payload: value
    }   
}

